export function forcePath(pathStr) {
  let globalObj;

  if(typeof window === 'object') {
    globalObj = window;
  }else if(typeof global === 'object') {
    globalObj = global;
  } else {
    throw new Error('no global object available');
  }

  return pathStr.split('.').reduce((curr, next) => {
    if(typeof curr[next] === 'undefined') {
      curr[next] = {};
    }
    return curr[next];
  }, globalObj);
}

// mimics Object.assign except first arg is a string path of the object you want to merge
// globalAssign('anObject.otherObj', {a: 1}, {b: 2})
// >> window.anOject.otherObj = {a: 1, b: 2}
export default function globalAssign(pathStr, ...assignees) {
  return Object.assign(forcePath(pathStr), ...assignees);
}
